/**
 * help-web's default greeting chips, shown when traffic intent supplies no chips (`suggestion_chips`
 * absent, `null`, or `[]`). A nonempty intent list replaces these wholesale.
 *
 * Interim selection: each chip is a shopping request grounded in the Walmart catalogs imported today —
 * 9671 Personal Care, 9673 Media and Gaming, 9674 Cameras and Supplies, 9743 Pets and Supplies
 * (`WalmartBrandConfig.cs`) — chosen from imported inventory, not category names alone. When catalog
 * coverage expands, revise this list by hand: nothing derives from it and there is no catalog registry.
 *
 * Labels must stay unique — `SuggestionChips` keys each chip by its label.
 */
export const DEFAULT_SUGGESTIONS: { label: string; prompt: string }[] = [
  { label: "Beard Trimmers", prompt: "Show me beard trimmers for men" },
  { label: "Switch Games", prompt: "What are some popular Nintendo Switch games?" },
  { label: "Rock Vinyl", prompt: "Show me rock vinyl records" },
  { label: "Instant Cameras", prompt: "Recommend an instant camera like the Fujifilm Instax Mini" },
  { label: "Cat Trees", prompt: "Find a cat tree for indoor cats" },
  { label: "Dog Chew Toys", prompt: "Show me durable chew toys for dogs" },
];
